import React, { useEffect, useMemo, useState } from "react";
import { listClientNetworkLogos } from "../services/networkLogo";
import {
    getNetworkBrandingPrefs,
    setNetworkBrandingPrefs,
} from "../utils/networkBranding";

const NetworkBrandingSettings = ({ compact = false }) => {
    const [items, setItems] = useState([]);
    const [prefs, setPrefs] = useState(() => getNetworkBrandingPrefs());
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const data = await listClientNetworkLogos();
                if (cancelled) return;
                setItems(Array.isArray(data?.items) ? data.items : []);
            } catch (_) {
                if (!cancelled) setItems([]);
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => { cancelled = true; };
    }, []);

    const withLogo = useMemo(
        () => (Array.isArray(items) ? items : []).filter((x) => x?.logo_url),
        [items],
    );

    const updatePrefs = (patch) => {
        const next = setNetworkBrandingPrefs(patch);
        setPrefs(next);
        try {
            window.dispatchEvent(new Event("wr-network-branding-changed"));
        } catch (_) {
            // ignore
        }
    };

    if (loading) {
        return compact ? null : <p className="profile-field-note">Завантаження брендингу…</p>;
    }

    if (!withLogo.length) {
        return (
            <p className="profile-field-note">
                Жодна з ваших мереж ще не має логотипу — показується звичайний вигляд.
            </p>
        );
    }

    const multi = withLogo.length > 1;

    return (
        <div className={`network-branding-settings ${compact ? "is-compact" : ""}`}>
            {!compact ? <p className="profile-settings-title">Логотип мережі</p> : null}
            <p className="profile-field-note">
                {multi
                    ? "Логотип у шапці. Можна обертати щогодини, закріпити одну мережу або вимкнути."
                    : `Показується логотип: ${withLogo[0].network_name || "мережа"}.`}
            </p>

            <div className="network-branding-options">
                <label className="wr-app-lock-toggle">
                    <input
                        type="radio"
                        name="network-branding-mode"
                        checked={prefs.mode !== "off" && (multi ? prefs.mode === "rotate" : true)}
                        onChange={() => updatePrefs({
                            mode: "rotate",
                            pinnedNetworkId: null,
                        })}
                    />
                    <span>{multi ? "Обертати щогодини" : "Показувати логотип"}</span>
                </label>

                {multi ? (
                    <label className="wr-app-lock-toggle">
                        <input
                            type="radio"
                            name="network-branding-mode"
                            checked={prefs.mode === "pin"}
                            onChange={() => updatePrefs({
                                mode: "pin",
                                pinnedNetworkId: prefs.pinnedNetworkId || withLogo[0].network_id,
                            })}
                        />
                        <span>Закріпити одну мережу</span>
                    </label>
                ) : null}

                <label className="wr-app-lock-toggle">
                    <input
                        type="radio"
                        name="network-branding-mode"
                        checked={prefs.mode === "off"}
                        onChange={() => updatePrefs({ mode: "off" })}
                    />
                    <span>Не показувати логотип</span>
                </label>
            </div>

            {multi && prefs.mode === "pin" ? (
                <label className="network-branding-pin">
                    <span>Мережа</span>
                    <select
                        value={prefs.pinnedNetworkId || withLogo[0].network_id}
                        onChange={(e) => updatePrefs({
                            mode: "pin",
                            pinnedNetworkId: parseInt(e.target.value, 10),
                        })}
                    >
                        {withLogo.map((item) => (
                            <option key={item.network_id} value={item.network_id}>
                                {item.network_name || `Мережа #${item.network_id}`}
                            </option>
                        ))}
                    </select>
                </label>
            ) : null}
        </div>
    );
};

export default NetworkBrandingSettings;
